import withInlProvider from 'components/HOC/withIntlProvider';
import React from 'react';
import { useDispatch } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import { SWRConfig } from 'swr';

import Routes from './routes';

const App = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    (async () => {
      try {
        const language = navigator.language.split('-')[0];
        const { data: lookAndFeel } = await services.getLookAndFeelSettings(language);
        dispatch(actions.app.setLookAndFeel(lookAndFeel));
      } catch (e) {
        console.error(e);
      }
    })();
  }, [dispatch]);

  return (
    <SWRConfig value={{ revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false }}>
      <Routes />;
    </SWRConfig>
  );
};

export default withInlProvider(App, 1);
